import { ReactSVG } from 'react-svg';
import * as S from './styles';

interface IProps {
  loading: boolean;
  text?: string;
}

const AppLoading: React.FC<IProps> = ({ loading, text }) => {
  if (loading) {
    return (
      <S.loadingContainer className="loading">
        <S.animation>
          <img src="/logos/logo-mini.png" width={120} height={120} alt="" />
        </S.animation>
        <S.Loader>
          <ReactSVG
            src="/loader.svg"
            wrapper="span"
            beforeInjection={(svg) => {
              svg.setAttribute('width', `130px`);
              svg.setAttribute('height', `130px`);
            }}
          />
        </S.Loader>
        {text && <S.loadingText>{text}</S.loadingText>}
      </S.loadingContainer>
    );
  } else return <></>;
};

export default AppLoading;
